import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ProductCardComponent } from '../product-card/product-card.component';
import { IvyCarouselModule } from 'angular-responsive-carousel2';

@Component({
  selector: 'app-general-carousel',
  templateUrl: './general-carousel.component.html',
  styleUrls: ['./general-carousel.component.scss'],
  standalone: true,
  imports: [IvyCarouselModule, ProductCardComponent]


})
export class GeneralCarouselComponent {
  @Input() products: any;
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.isBrowser) this.isMobile = window.innerWidth <= 800;
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
  }

  public isMobile: boolean;
  public isBrowser: boolean;
  public carouselProductsHeight = 335;
  public carouselProductsWidth = 200;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) this.isMobile = window.innerWidth <= 800;
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
  }
}
